import React, { useState, useContext, useEffect } from "react";
import {
    AppContainer,
    AppLeftPane,
    AppContent,
    AppMainContent,
    Collapsible,
    CollapsibleContainer,
    Icon,
    SidebarNavi,
    SidebarNaviTile,
    Checkbox
} from "@abb/abb-common-ux-react";
import { RootContext } from "../../contexts/root-context";
import "./left-pane.css";
import config from './left-pane.json';
import substationsData from '../Google-Map/dummy-substations.json';

const LOCAL_STORAGE_KEYS = {
    SAOA: "SAOA",
    ORList: "ORList",
    SubTypeList: "SubTypeList",
    SAST: "SAST",
    selectedSubTypes: "selectedSubTypes",
    opsArea: "opsarea",
    primaryFilter: "primaryFilter",
    selectedOpsAreas: "selectedOpsAreas"
};


const LeftpaneComponent = () => {
    const { isLeftPaneOpen, setisLeftPaneOpen, setprimaryFilter, setOpsAreaFilter } = useContext(RootContext);
    const [sidebarNaviStates, setSidebarNaviStates] = useState({
        search: false,
        filters: true
    });
    const [collapsed, setCollapsed] = useState(false);
    const [theme, setTheme] = useState("light");
    const [searchBar, setSearchBar] = useState(false);
    const [border, setBorder] = useState(false);
    const [isTitleFor, setisTitleFor] = useState("filters");
    const [isInline, setIsInline] = useState(false);
    const [leftPaneFilter, setLeftPaneFilter] = useState("");
    const [currentTile, setCurrentTile] = useState("filters");
    const [subTypeCheckedItems, setSubTypeCheckedItems] = useState({})
    const [opsAreacheckedItems, setOpsAreaCheckedItems] = useState({})
    const [ORList, setORList] = useState([]);
    const [isError, setError] = useState([]);
    const [subTypeList, setSubTypeList] = useState([]);
    const [substationNameList, setSubstationNameList] = useState([]);
    const [substationNameCheckedItems, setSubstationNameCheckedItems] = useState({});
    const [selectAllSubstationType, setSelectAllSubstationType] = useState(true);
    const [selectAllOperationAreas, setSelectAllOperationAreas] = useState(true);
    const [selectAllSubstationNames, setSelectAllSubstationNames] = useState(true);

    useEffect(() => {
        // Process dummy data instead of fetching from API
        processDummyData();
    }, []);

    const processDummyData = () => {
        // Extract unique operation areas
        const operationAreas = substationsData.map(item => item.operationArea);
        const uniqueOperationAreas = [...new Set(operationAreas)];
        setORList(uniqueOperationAreas);
        
        // Extract unique substation types
        const types = substationsData.map(item => item.type);
        const uniqueTypes = [...new Set(types)];
        setSubTypeList(uniqueTypes);
        
        // Extract substation names
        const names = substationsData.map(item => item.name);
        const uniqueNames = [...new Set(names)];
        setSubstationNameList(uniqueNames);
        
        // Initialize checkbox states
        setSubTypeCheckedItems(uniqueTypes.reduce((acc, item) => {
            acc[item] = true;
            return acc;
        }, {}));
        
        setOpsAreaCheckedItems(uniqueOperationAreas.reduce((acc, area) => {
            acc[area] = true;
            return acc;
        }, {}));
        
        setSubstationNameCheckedItems(uniqueNames.reduce((acc, name) => {
            acc[name] = true;
            return acc;
        }, {}));
        
        // Save to localStorage for persistence
        localStorage.setItem(LOCAL_STORAGE_KEYS.ORList, JSON.stringify(uniqueOperationAreas));
        localStorage.setItem(LOCAL_STORAGE_KEYS.SubTypeList, JSON.stringify(uniqueTypes));
        localStorage.setItem("SubstationNameList", JSON.stringify(uniqueNames));
    };

    const na = "NA"
    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_KEYS.primaryFilter, subTypeCheckedItems ? JSON.stringify(subTypeCheckedItems) : na);
        localStorage.setItem(LOCAL_STORAGE_KEYS.opsArea, opsAreacheckedItems ? JSON.stringify(opsAreacheckedItems) : na);
        localStorage.setItem(LOCAL_STORAGE_KEYS.SAST, selectAllSubstationType);
        localStorage.setItem(LOCAL_STORAGE_KEYS.SAOA, selectAllOperationAreas);
        localStorage.setItem("selectAllSubstationNames", selectAllSubstationNames);
        localStorage.setItem("substationNameCheckedItems", JSON.stringify(substationNameCheckedItems));
    }, [subTypeCheckedItems, opsAreacheckedItems, selectAllSubstationType, selectAllOperationAreas, substationNameCheckedItems, selectAllSubstationNames]);

    const activateSidebarTile = (tile) => {
        setCurrentTile(tile);
        if (tile === "search") {
            setisTitleFor(config.titleSearch);
        } else {
            setisTitleFor(config.titleFilters);
        }
        const updatedSidebarNaviStates = {};
        Object.keys(sidebarNaviStates).map((v) => (updatedSidebarNaviStates[v] = v === tile));
        if (updatedSidebarNaviStates) {
            setSidebarNaviStates(updatedSidebarNaviStates);
        }
    };

    const handleSubTypeCheckboxChange = (item) => {
        setSubTypeCheckedItems(prevState => ({
            ...prevState,
            [item]: !prevState[item]
        }));
        const selectedTypes = Object.entries(subTypeCheckedItems)
            .filter(([key, value]) => value === true)
            .map(([key]) => key);
        setprimaryFilter(selectedTypes)

        setSelectAllSubstationType(false);
        localStorage.setItem(LOCAL_STORAGE_KEYS.SAST, JSON.stringify(selectAllSubstationType));
        localStorage.setItem(LOCAL_STORAGE_KEYS.selectedSubTypes, JSON.stringify(selectedTypes));
    };

    const handleOpsAreaCheckboxChange = (area) => {
        setOpsAreaCheckedItems(prevState => ({
            ...prevState,
            [area]: !prevState[area]
        }));
        const selectedAreas = Object.entries(opsAreacheckedItems)
            .filter(([key, value]) => value === true)
            .map(([key]) => key);
        setOpsAreaFilter(selectedAreas)
        setSelectAllOperationAreas(false);
        localStorage.setItem(LOCAL_STORAGE_KEYS.SAOA, JSON.stringify(selectAllOperationAreas));
        localStorage.setItem(LOCAL_STORAGE_KEYS.selectedOpsAreas, JSON.stringify(selectedAreas));
    };

    const handleSubstationNameCheckboxChange = (name) => {
        setSubstationNameCheckedItems(prevState => ({
            ...prevState,
            [name]: !prevState[name]
        }));
        const selectedNames = Object.entries(substationNameCheckedItems)
            .filter(([key, value]) => value === true)
            .map(([key]) => key);
        
        // You may want to add a context function to filter by name
        // Similar to setprimaryFilter and setOpsAreaFilter
        
        setSelectAllSubstationNames(false);
        localStorage.setItem("selectAllSubstationNames", JSON.stringify(selectAllSubstationNames));
        localStorage.setItem("selectedSubstationNames", JSON.stringify(selectedNames));
    };

    const handleSelectAllSubstationType = () => {
        setSelectAllSubstationType(!selectAllSubstationType);
        const updatedCheckedItems = subTypeList?.reduce((acc, item) => {
            acc[item] = !selectAllSubstationType;
            return acc;
        }, {});
        setSubTypeCheckedItems(updatedCheckedItems);
        setprimaryFilter(selectAllSubstationType ? [] : subTypeList);
    };

    const handleSelectAllOperationAreas = () => {
        setSelectAllOperationAreas(!selectAllOperationAreas);
        const updatedOpsAreaCheckedItems = ORList?.reduce((acc, area) => {
            acc[area] = !selectAllOperationAreas;
            return acc;
        }, {});
        setOpsAreaCheckedItems(updatedOpsAreaCheckedItems);
        setOpsAreaFilter(selectAllOperationAreas ? [] : ORList);
    };

    const handleSelectAllSubstationNames = () => {
        setSelectAllSubstationNames(!selectAllSubstationNames);
        const updatedNameCheckedItems = substationNameList?.reduce((acc, name) => {
            acc[name] = !selectAllSubstationNames;
            return acc;
        }, {});
        setSubstationNameCheckedItems(updatedNameCheckedItems);
        // You may want to add a context function to filter by name
    };

    return (
        <div className="left-pane-container">
            <AppContainer theme={theme} className="filter-container-main" style={{ height: "calc(100% - 16px)", position: "absolute", zIndex: 3, minWidth: "30px" }}>
                <AppContent style={{ width: "100%", background: "none" }}>
                    <AppLeftPane
                        searchValue={leftPaneFilter}
                        className="filter-app-left-pane"
                        icon={config.icon}
                        showSearchBarInFullMode={searchBar}
                        title={isTitleFor === "search" ? <span className="pane-header">{config.titleSearch}</span> : <span className="pane-header">{config.titleFilters}</span>}
                        searchBarPositionInFullMode={isInline ? "below" : "inline"}
                        searchBarPlaceholder={config.searchBarPlaceholder}
                        showRightBorder={border}
                        onSearchValueChange={(value) => setLeftPaneFilter(value)}
                        visibility={isLeftPaneOpen}
                        onClickToggleVisibility={() => {
                            setCollapsed(!collapsed);
                            setisLeftPaneOpen(collapsed ? "full" : "thumbs");
                        }}
                    >
                        {isLeftPaneOpen === "full" && (
                            <CollapsibleContainer filter={leftPaneFilter}>
                                <SidebarNavi style={config.sidebarNaviStyle} className="filter-sidebar-navi">
                                    <SidebarNaviTile
                                        onClick={(e) => activateSidebarTile("filters")}
                                        style={{ background: "none" }}
                                        active={sidebarNaviStates?.filters}
                                        mode={"thumbs"}
                                        title="Filters"
                                    >
                                        <Icon name={config.iconSettings.name} sizeClass={config.iconSettings.sizeClass} />
                                    </SidebarNaviTile>
                                </SidebarNavi>
                                <AppMainContent style={config.appMainContentStyle}>
                                    {currentTile === "filters" && (
                                        <div style={config.collapsibleContainerStyle}>
                                            <CollapsibleContainer>
                                                {/* Substation Names Section */}
                                                <Collapsible itemId="sub-names" className="filters-header" title="Substation Names">
                                                    <Checkbox
                                                        sizeClass={config.checkboxSizeClass}
                                                        label="Select All"
                                                        monochrome={true}
                                                        value={selectAllSubstationNames}
                                                        onChange={() => handleSelectAllSubstationNames()}
                                                    />
                                                    {substationNameList.map((name, index) => (
                                                        <Checkbox
                                                            key={index}
                                                            sizeClass={config.checkboxSizeClass}
                                                            monochrome={true}
                                                            label={name}
                                                            value={substationNameCheckedItems[name]}
                                                            tile={name}
                                                            className={config.checkboxClassName}
                                                            onChange={() => handleSubstationNameCheckboxChange(name)}
                                                        />
                                                    ))}
                                                </Collapsible>
                                                
                                                {/* Substation Type Section
                                                {config.showSubstationType && subTypeList && subTypeList.length > 0 ? (
                                                    <Collapsible itemId="sub-type" className="filters-header" title={config.substationTypeTitle}>
                                                        <Checkbox
                                                            sizeClass={config.checkboxSizeClass}
                                                            label="Select All"
                                                            monochrome={true}
                                                            value={selectAllSubstationType}
                                                            onChange={() => handleSelectAllSubstationType()}
                                                        />
                                                        {subTypeList.map((item, index) => (
                                                            <Checkbox
                                                                key={index}
                                                                sizeClass={config.checkboxSizeClass}
                                                                monochrome={true}
                                                                label={item}
                                                                value={subTypeCheckedItems[item]}
                                                                tile={item}
                                                                className={config.checkboxClassName}
                                                                onChange={() => handleSubTypeCheckboxChange(item)}
                                                            />
                                                        ))}
                                                    </Collapsible>
                                                ) : (
                                                    <div></div>
                                                )} */}
                                                
                                                {/* Operation Areas Section */}
                                                {config.showOperationAreas && ORList && ORList.length > 0 ? (
                                                    <Collapsible itemId="sub-sites" className="filters-header" title={config.operationAreasTitle}>
                                                        <Checkbox
                                                            sizeClass={config.checkboxSizeClass}
                                                            label="Select All"
                                                            monochrome={true}
                                                            value={selectAllOperationAreas}
                                                            onChange={() => handleSelectAllOperationAreas()}
                                                        />
                                                        {ORList.map((area) => (
                                                            <Checkbox
                                                                key={area}
                                                                sizeClass={config.checkboxSizeClass}
                                                                label={area}
                                                                monochrome={true}
                                                                value={opsAreacheckedItems[area]}
                                                                onChange={() => handleOpsAreaCheckboxChange(area)}
                                                            />
                                                        ))}
                                                    </Collapsible>
                                                ) : (
                                                    <div></div>
                                                )}
                                            </CollapsibleContainer>
                                        </div>
                                    )}
                                </AppMainContent>
                            </CollapsibleContainer>
                        )}
                        {isLeftPaneOpen === "thumbs" && (
                            <CollapsibleContainer filter={leftPaneFilter}>
                                <SidebarNavi style={config.sidebarNaviStyle} className="filter-sidebar-navi">
                                    <SidebarNaviTile
                                        onClick={(e) => activateSidebarTile("filters")}
                                        style={{ background: "none" }}
                                        active={sidebarNaviStates?.filters}
                                        mode={"thumbs"}
                                        title="Filters"
                                    >
                                        <Icon name={config.iconSettings.name} sizeClass={config.iconSettings.sizeClass} />
                                    </SidebarNaviTile>
                                </SidebarNavi>
                            </CollapsibleContainer>
                        )}
                    </AppLeftPane>
                </AppContent>
            </AppContainer>
        </div>
    );
};

export default LeftpaneComponent;